export default "__VITE_ASSET__BSLnTrhb__"